// extracted by mini-css-extract-plugin
export default {"tag":"TagComponent_tag__7zHpx"};